import { sb } from '../../../supabase.ts';
import { escapeHtml } from '../../../main.ts';

export async function renderOtherSchoolTcWordPage(app: HTMLElement): Promise<void> {
  const tableName = 'termination_table_others';

  const urlParams = new URLSearchParams(window.location.search);
  const iidParam = urlParams.get('iid') || '';
  const slParam = urlParams.get('sl') || '';

  app.innerHTML = `
    <style>
      :root {
        --box-left: 31%;
        --box-right: 5%;
        --box-top: 30%;
        --box-bottom: 22%;
        --serial-top: 21%;
        --serial-left: 38%;
        --date-top: 21%;
        --date-right: 7%;
        --leftpanel-left: 4.5%;
        --leftpanel-right: 74%;
        --leftpanel-top: 18%;
        --leftpanel-bottom: 8%;
        --qr-size: 80px;
        --qr-bottom: 12%;
        --qr-right: 30%;
        --qr-border: rgba(17, 17, 17, 0.8);
        --qr-ink: #000000;
        --qr-caption: #111111;
        --qr-meta: #334155;
      }
      .cert-wrap-page {
        font-family: 'Times New Roman', Times, serif;
        margin: 0;
        background: #f8fafc;
        color: #1e293b;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 60px;
      }
      .cert-header {
        position: sticky;
        top: 0;
        width: 100%;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.8));
        padding: 12px 24px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        z-index: 10;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
      }
      .cert-header h1 {
        margin: 0;
        font-size: 16px;
        font-family: system-ui, -apple-system, sans-serif;
        font-weight: 800;
        color: #0f172a;
      }
      .cert-status {
        font-size: 13px;
        color: #64748b;
        font-family: system-ui, -apple-system, sans-serif;
      }
      .layout {
        display: flex;
        gap: 24px;
        align-items: flex-start;
        justify-content: center;
        margin: 24px auto;
        padding: 0 16px;
        box-sizing: border-box;
        width: 100%;
        max-width: 1100px;
      }
      .img-wrap {
        position: relative;
        width: 600px;
        min-width: 320px;
        max-width: 100%;
        aspect-ratio: 842 / 595; /* A4 landscape ratio */
      }
      .img-wrap img {
        width: 100%;
        height: auto;
        display: block;
        border-radius: 12px;
        box-shadow: 0 10px 35px rgba(0,0,0,0.06);
        border: 1px solid rgba(0, 0, 0, 0.08);
      }
      .overlay {
        position: absolute;
        inset: var(--box-top) var(--box-right) var(--box-bottom) var(--box-left);
        display: block;
      }
      .overlay-left {
        position: absolute;
        inset: var(--leftpanel-top) var(--leftpanel-right) var(--leftpanel-bottom) var(--leftpanel-left);
        overflow: hidden;
      }
      .overlay-text {
        font-size: clamp(6.3px, 0.84vw, 12px);
        line-height: 1.15;
        color: #111;
        white-space: pre-line;
        text-align: justify;
        text-justify: inter-word;
        word-break: normal;
        hyphens: none;
        overflow-wrap: break-word;
      }
      .overlay-text .emph {
        font-size: 110%;
        font-weight: bold;
      }
      .left-text {
        font-size: clamp(7.2px, 0.855vw, 10.8px);
        line-height: 1.35;
        white-space: pre-line;
        color: #111;
      }
      .left-text .hl {
        font-weight: 700;
        text-decoration: underline;
      }
      .field {
        position: absolute;
        font-size: clamp(9px, 1vw, 11px);
        line-height: 1;
        color: #111;
        font-weight: bold;
      }
      .serial {
        top: var(--serial-top);
        left: var(--serial-left);
        text-align: left;
      }
      .date {
        top: var(--date-top);
        right: var(--date-right);
        text-align: right;
      }
      .qr-wrap {
        position: absolute;
        bottom: var(--qr-bottom);
        right: var(--qr-right);
        width: var(--qr-size);
        background: #ffffff;
        border: 2px solid var(--qr-border);
        border-radius: 12px;
        padding: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        overflow: visible;
      }
      .qr-wrap canvas, .qr-wrap svg, .qr-wrap img {
        width: 100% !important;
        height: auto !important;
        display: block;
        border-radius: 4px;
        mix-blend-mode: multiply;
      }
      .qr-caption {
        font-size: 7px;
        line-height: 1.1;
        margin-top: 3px;
        font-family: system-ui, Arial, sans-serif;
        letter-spacing: .3px;
        color: var(--qr-caption);
        text-transform: uppercase;
        font-weight: 800;
      }
      .qr-meta {
        font-size: 6px;
        line-height: 1.2;
        margin-top: 1px;
        font-family: system-ui, Arial, sans-serif;
        letter-spacing: .2px;
        color: var(--qr-meta);
        text-align: center;
        width: 100%;
        white-space: normal;
        overflow: visible;
        word-break: break-word;
      }
      .action-bar {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 12px;
        background: rgba(255, 255, 255, 0.95);
        padding: 10px 18px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        backdrop-filter: blur(6px);
        z-index: 100;
      }
      .btn-print {
        background: #2563eb;
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 8px 16px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.2s;
        font-family: system-ui, -apple-system, sans-serif;
      }
      .btn-print:hover {
        background: #1d4ed8;
      }
      .btn-pdf {
        background: #10b981;
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 8px 16px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.2s;
        font-family: system-ui, -apple-system, sans-serif;
      }
      .btn-pdf:hover {
        background: #059669;
      }
      .secondary-btn {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        color: #475569;
        border-radius: 8px;
        padding: 10px 16px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.2s;
        display: inline-block;
        text-align: center;
      }
      .secondary-btn:hover {
        background: #f8fafc;
        border-color: rgba(0, 0, 0, 0.2);
        color: #0f172a;
      }
      .warning-card {
        max-width: 600px;
        margin: 40px auto;
        padding: 24px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        background: #ffffff;
        box-shadow: 0 10px 30px rgba(0,0,0,0.04);
        text-align: center;
        font-family: system-ui, -apple-system, sans-serif;
      }
      .warning-card h2 {
        color: #d97706;
        margin-top: 0;
      }
      .warning-card p {
        font-size: 14px;
        line-height: 1.5;
        color: #475569;
      }

      @media print {
        @page {
          size: A4 landscape;
          margin: 8mm;
        }
        body, .cert-wrap-page {
          background: #fff !important;
          color: #000 !important;
          padding: 0 !important;
        }
        .cert-header, .action-bar {
          display: none !important;
        }
        .layout {
          margin: 0 !important;
          padding: 0 !important;
        }
        .img-wrap {
          width: 100% !important;
          max-width: 100% !important;
          box-shadow: none !important;
          border: none !important;
        }
        .img-wrap img {
          box-shadow: none !important;
          border: none !important;
          border-radius: 0 !important;
        }
        .overlay-text, .field, .left-text, .qr-caption, .qr-meta {
          color: #000 !important;
        }
        .img-wrap, .img-wrap * {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      }
    </style>

    <div class="cert-wrap-page" id="certPageContent">
      <div class="cert-header">
        <h1>Transfer Certificate Preview</h1>
        <div class="cert-status" id="certStatus">Querying database...</div>
      </div>

      <div id="layoutContainer" style="display: none; width: 100%;">
        <div class="layout">
          <div class="img-wrap" id="printArea">
            <img src="/z_others/TC/testimonial.png" alt="Certificate background" crossorigin="anonymous" />
            <div class="field serial">SL: <span id="serialVal"></span></div>
            <div class="field date">Date: <span id="dateVal"></span></div>
            
            <div class="overlay-left">
              <div id="leftPanel" class="left-text"></div>
            </div>
            
            <div class="overlay">
              <div id="imgText" class="overlay-text"></div>
            </div>

            <!-- Verification QR Code Overlay -->
            <div class="qr-wrap" title="Verify online">
              <div id="qrBox" style="width:100%; height:var(--qr-size);"></div>
              <div class="qr-caption">Scan to Verify</div>
              <div class="qr-meta" id="qrIssued"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="action-bar" id="actionBar" style="display: none;">
        <button class="btn-print" id="printBtn">🖨️ Print</button>
        <button class="btn-pdf" id="pdfBtn">📥 Download PDF</button>
      </div>
    </div>
  `;

  const certStatus = document.getElementById('certStatus')!;
  const layoutContainer = document.getElementById('layoutContainer')!;
  const actionBar = document.getElementById('actionBar')!;
  const serialVal = document.getElementById('serialVal')!;
  const dateVal = document.getElementById('dateVal')!;
  const leftPanel = document.getElementById('leftPanel')!;
  const imgText = document.getElementById('imgText')!;
  const qrIssued = document.getElementById('qrIssued')!;
  const printArea = document.getElementById('printArea')!;

  const printBtn = document.getElementById('printBtn')!;
  const pdfBtn = document.getElementById('pdfBtn')!;

  // Dynamic helper script loaders
  async function loadScript(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${url}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
      document.head.appendChild(script);
    });
  }

  // Load CDN scripts for QR Code styling, Html2canvas, jsPDF sequentially
  async function loadDependencies() {
    try {
      await loadScript('https://cdn.jsdelivr.net/npm/qr-code-styling@1.6.0/lib/qr-code-styling.js');
    } catch (e) {
      // Fallback: plain qrcode lib
      try {
        await loadScript('https://cdn.jsdelivr.net/npm/qrcode@1.5.3/build/qrcode.min.js');
      } catch (e2) {
        console.warn('Failed to load any QR library:', e2);
      }
    }
    try {
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
    } catch (e) {
      try {
        await loadScript('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js');
      } catch (e2) {
        console.warn('Failed to load html2canvas:', e2);
      }
    }
    try {
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
    } catch (e) {
      try {
        await loadScript('https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js');
      } catch (e2) {
        console.warn('Failed to load jsPDF:', e2);
      }
    }
  }

  function defaultDate(raw: string) {
    if (raw) return raw;
    const d = new Date();
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  function showMissingSlWarning() {
    const mainWrap = document.getElementById('certPageContent')!;
    mainWrap.innerHTML = `
      <div class="warning-card">
        <h2>⚠️ Serial Number (SL) Missing</h2>
        <p>This Transfer Certificate record does not contain a Serial Number (SL). The certificate background layout requires a valid SL. Please allocate a TC Serial in the TC list or details panel first.</p>
        <div style="margin-top: 20px;">
          <a href="/other_school/tc/test_list" class="secondary-btn" style="background: #10b981; color: white; border: none; font-weight: 700;">Back to TC List</a>
        </div>
      </div>
    `;
  }

  async function loadCertificate() {
    if (!iidParam && !slParam) {
      certStatus.textContent = 'Parameter iid or sl is missing.';
      certStatus.style.color = '#dc2626';
      return;
    }

    try {
      let rec: any = null;

      // 1. Try termination_table_others first
      let query = sb.from(tableName).select('*').limit(1);
      if (iidParam) query = query.eq('iid', iidParam);
      if (slParam) query = query.eq('tc_sl', slParam);

      const { data, error } = await query;
      if (error) throw error;

      if (data && data.length) {
        rec = data[0];
      } else if (iidParam) {
        // 2. Fallback: look up student_database_others for legacy TC records
        certStatus.textContent = 'Checking student database for legacy record...';
        const { data: stuData, error: stuErr } = await sb
          .from('student_database_others')
          .select('*')
          .eq('iid', iidParam)
          .limit(1);

        if (stuErr) throw stuErr;

        if (stuData && stuData.length) {
          const stu = stuData[0];
          const session = stu.session || 2025;
          // Map student record fields to termination_table format
          rec = {
            tc_sl: stu.tc_no || null,
            iid: stu.iid,
            student_name_en: stu.student_name_en || stu.name_en || '',
            father_name_en: stu.father_name_en || '',
            mother_name_en: stu.mother_name_en || '',
            tc_class: stu[`class_${session}`] || stu.class || '',
            tc_section: stu[`section_${session}`] || stu.section || '',
            tc_roll: stu[`roll_${session}`] || stu.roll || '',
            board_registration: stu.board_registration || '',
            student_dateofbirth: stu.student_dateofbirth || '',
            student_gender: stu.student_gender || '',
            paid_month: stu.paid_month || 'December 2025',
            student_character: stu.student_character || 'very good',
            next_class: stu.next_class || '',
            tc_session: String(session),
            issued_by: stu.issued_by || '',
            father_mobile: stu.father_mobile || stu.guardian_mobile || '',
            tc_date: stu.tc_date || '',
            note: stu.comment_school || '',
            _fromStudentDb: true
          };
        }
      }

      if (!rec) {
        certStatus.textContent = 'Record not found in any database table.';
        certStatus.style.color = '#dc2626';
        return;
      }

      if (!rec.tc_sl) {
        showMissingSlWarning();
        return;
      }

      // Populate text overlays
      serialVal.textContent = String(rec.tc_sl);
      dateVal.textContent = defaultDate(rec.tc_date);

      // Gender appropriate parameters
      const g = String(rec.student_gender || '').toLowerCase();
      const isFemale = /^(f|female|girl)/.test(g);
      const childWord = isFemale ? 'daughter' : 'son';
      const heShe = isFemale ? 'She' : 'He';
      const hisHer = isFemale ? 'Her' : 'His';

      const regVal = String(rec.board_registration || '').trim();
      const examSentence = String(rec.next_class || '').trim() ? ` and had passed last the Annual Examination for promotion to class <strong class="emph"><u>${escapeHtml(rec.next_class)}</u></strong>.` : '.';
      const regPart = regVal && regVal !== '---' ? `Board Registration number is <strong>${escapeHtml(regVal)}</strong>. ` : '';

      // Main Paragraph Content (Bilingual structure matched to original school)
      imgText.innerHTML = `
        This is certify that <strong class="emph"><u>${escapeHtml(rec.student_name_en)}</u></strong> ${childWord} of <strong>${escapeHtml(rec.father_name_en)}</strong> and <strong>${escapeHtml(rec.mother_name_en)}</strong> student's of Feni Model High School. ${heShe} was studying in class <strong class="emph"><u>${escapeHtml(rec.tc_class)}</u></strong>, Roll: <strong class="emph"><u>${escapeHtml(rec.tc_roll)}</u></strong>, Section: <strong class="emph"><u>${escapeHtml(rec.tc_section)}</u></strong> in Bangla version, Session- <strong>${escapeHtml(rec.tc_session)}</strong>${examSentence}<br/>
        ${regPart}As per record ${hisHer} date of birth is <strong>${escapeHtml(rec.student_dateofbirth)}</strong> and has paid the school dues till <strong>${escapeHtml(rec.paid_month)}</strong>.<br/>
        ${hisHer} character is <strong>${escapeHtml(rec.student_character)}</strong>. I wish ${isFemale ? 'her' : 'him'} every success in future.
      `;

      // Left Panel Sidebar Details
      const sidebarItems = [
        ['SL', rec.tc_sl],
        ['IID', rec.iid],
        ['Name', rec.student_name_en],
        ['Father', rec.father_name_en],
        ['Mother', rec.mother_name_en],
        ['Class', rec.tc_class],
        ['Section', rec.tc_section],
        ['Roll', rec.tc_roll],
        ['Reg No', rec.board_registration || '---'],
        ['DOB', rec.student_dateofbirth],
        ['Paid Month', rec.paid_month],
        ['Mobile', rec.father_mobile],
        ['Session', rec.tc_session],
        ['Issued By', rec.issued_by],
      ];

      leftPanel.innerHTML = sidebarItems.map(([key, val]) => {
        const isHighlight = ['Name', 'Class', 'Section', 'Roll'].includes(key);
        const displayVal = isHighlight ? `<span class="hl">${escapeHtml(String(val ?? ''))}</span>` : escapeHtml(String(val ?? ''));
        return `${key}: ${displayVal}`;
      }).join('<br/>');

      qrIssued.textContent = 'Issued By: ' + (rec.issued_by || '');

      // QR URL for verification
      const verifyUrl = new URL('/other_school/tc', window.location.origin);
      verifyUrl.searchParams.set('iid', String(rec.iid));
      const verifyString = verifyUrl.toString();

      // Render styled QR Code
      const qrBox = document.getElementById('qrBox')!;
      qrBox.innerHTML = '';

      const QRCodeStyling = (window as any).QRCodeStyling;
      const qrPixelSize = 160; // internal render size (px)

      if (QRCodeStyling) {
        try {
          const qrCode = new QRCodeStyling({
            width: qrPixelSize,
            height: qrPixelSize,
            type: 'canvas',
            data: verifyString,
            dotsOptions: {
              color: '#000000',
              type: 'rounded'
            },
            cornersSquareOptions: {
              color: '#000000',
              type: 'extra-rounded'
            },
            cornersDotOptions: {
              color: '#000000',
              type: 'dot'
            },
            backgroundOptions: {
              color: 'transparent'
            },
            qrOptions: {
              errorCorrectionLevel: 'M'
            }
          });
          qrCode.append(qrBox);
        } catch (qrErr) {
          console.warn('QRCodeStyling render failed, falling back:', qrErr);
          fallbackQrService(verifyString, qrBox);
        }
      } else {
        // Try plain qrcode library as second fallback
        const qrcodeLib = (window as any).QRCode;
        if (qrcodeLib && typeof qrcodeLib.toCanvas === 'function') {
          const canvas = document.createElement('canvas');
          qrcodeLib.toCanvas(canvas, verifyString, {
            errorCorrectionLevel: 'M',
            margin: 1,
            scale: 6,
            color: { dark: '#000000', light: 'rgba(255, 255, 255, 0)' }
          }, (err: any) => {
            if (err) {
              fallbackQrService(verifyString, qrBox);
            } else {
              qrBox.appendChild(canvas);
            }
          });
        } else {
          fallbackQrService(verifyString, qrBox);
        }
      }

      layoutContainer.style.display = 'block';
      actionBar.style.display = 'flex';
      certStatus.textContent = 'Ready';
    } catch (e: any) {
      console.error(e);
      certStatus.textContent = 'Failed to load certificate data.';
      certStatus.style.color = '#dc2626';
    }
  }

  function fallbackQrService(url: string, container: HTMLElement) {
    container.innerHTML = '';
    const img = new Image();
    img.alt = 'QR Code';
    img.crossOrigin = 'anonymous';
    img.src = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + encodeURIComponent(url) + '&color=000000&bgcolor=FFFFFF';
    img.style.width = '100%';
    img.style.height = '100%';
    container.appendChild(img);
  }

  // Resolve jsPDF constructor from different CDN exposure patterns
  function getJsPdfConstructor(): any | null {
    const w = window as any;
    // UMD pattern: window.jspdf.jsPDF
    if (w.jspdf && w.jspdf.jsPDF) return w.jspdf.jsPDF;
    // Some versions expose window.jsPDF directly
    if (w.jsPDF) return w.jsPDF;
    // Some expose as window.jspdf directly (unlikely but guard)
    if (typeof w.jspdf === 'function') return w.jspdf;
    return null;
  }

  // PDF Download Trigger
  async function downloadPdf() {
    const pdfBtnEl = document.getElementById('pdfBtn') as HTMLButtonElement;
    if (pdfBtnEl) pdfBtnEl.disabled = true;
    certStatus.textContent = 'Generating PDF...';
    try {
      const html2canvasLib = (window as any).html2canvas;
      const JsPDF = getJsPdfConstructor();

      if (!html2canvasLib) {
        alert('html2canvas is still loading. Please wait a moment and try again.');
        certStatus.textContent = 'Ready';
        if (pdfBtnEl) pdfBtnEl.disabled = false;
        return;
      }
      if (!JsPDF) {
        alert('jsPDF library is still loading. Please wait a moment and try again.');
        certStatus.textContent = 'Ready';
        if (pdfBtnEl) pdfBtnEl.disabled = false;
        return;
      }

      const canvas = await html2canvasLib(printArea, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new JsPDF('landscape', 'pt', 'a4');
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();

      const imgW = pageW;
      const imgH = canvas.height * (imgW / canvas.width);
      const y = Math.max(0, (pageH - imgH) / 2);

      pdf.addImage(imgData, 'JPEG', 0, y, imgW, imgH);
      pdf.save(`transfer_certificate_${iidParam || 'record'}.pdf`);
      certStatus.textContent = 'PDF downloaded ✓';
    } catch (e: any) {
      console.error('PDF generation error:', e);
      alert('Failed to generate PDF. Error: ' + (e?.message || String(e)));
      certStatus.textContent = 'Error generating PDF';
    } finally {
      if (pdfBtnEl) pdfBtnEl.disabled = false;
    }
  }

  printBtn.onclick = () => window.print();
  pdfBtn.onclick = downloadPdf;

  // Load dependencies FIRST so PDF is ready when user clicks
  certStatus.textContent = 'Loading PDF libraries...';
  await loadDependencies();
  certStatus.textContent = 'Querying database...';
  await loadCertificate();
}
